import { Controller, useFormContext } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';

interface IProps {
  name: string;
}

export default function RHFUrlMaskField({ name, ...other }: IProps & TextFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          {...other}
          error={!!error}
          helperText={error?.message}
          fullWidth
          onChange={(e) => {
            const value = e.target.value.replace(/\s+/g, '-');
            field.onChange(value);
          }}
        />
      )}
    />
  );
}